import { Modal, Row, Col } from "react-bootstrap";

export function SharePopup({
  url,
  text,
  configuration,
  objectId,
  show,
  onHide,
}) {
  const content_type = configuration.content_type;
  const object_id = objectId || configuration.object_id;

  const shareFacebook = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=facebook&content_type=${content_type}&object_id=${object_id}`;
  const shareTwitter = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=twitter&content_type=${content_type}&object_id=${object_id}`;
  const shareWhatsApp = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=whatsapp&content_type=${content_type}&object_id=${object_id}`;
  const shareTelegram = `${configuration.shareUrl}?url=${window.location.protocol}//${window.location.hostname}${url}&text=${text}&type=telegram&content_type=${content_type}&object_id=${object_id}`;
  const shareEmail = `mailto:?subject=${text}&body=${window.location.protocol}//${window.location.hostname}${url}`;

  const isMobile = window.navigator.userAgent.search("Mobile") >= 0;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-5">
          {configuration.translations.shareMenuTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5">
        <Row className="text-center g-3">
          <Col>
            <a
              href={shareFacebook}
              target="_blank"
              rel="noreferrer"
              title="Facebook"
            >
              <i className="fa-brands fa-facebook fs-1" />
            </a>
          </Col>
          <Col>
            <a href={shareTwitter} target="_blank" rel="noreferrer" title="X">
              <i className="fa-brands fa-x-twitter fs-1" />
            </a>
          </Col>
          {isMobile && (
            <Col>
              <a
                href={shareWhatsApp}
                target="_blank"
                rel="noreferrer"
                title="WhatsApp"
              >
                <i className="fa-brands fa-whatsapp fs-1" />
              </a>
            </Col>
          )}
          <Col>
            <a
              href={shareTelegram}
              target="_blank"
              rel="noreferrer"
              title="Telegram"
            >
              <i className="fa-brands fa-telegram fs-1" />
            </a>
          </Col>
          <Col>
            <a href={shareEmail} target="_blank" rel="noreferrer" title="Email">
              <i className="fa-regular fa-envelope fs-1" />
            </a>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
